<div class="loading-screen-box">
  <div class="loading-screen-content">
    <div class="title" [innerHTML]="titleText"></div>
    <mat-progress-bar class="ddd-progress ddd-progress__line loading-line" mode="indeterminate"></mat-progress-bar>
  </div>
</div>
